const FirstVisitImage = () => (
  <div className="first-visit-image">
    <picture>
      <source srcSet="/images/misc/novotelstore-first-visit.webp" />
      <img alt="first visit" src="/images/misc/novotelstore-first-visit.jpg" />
    </picture>
  </div>
);

export default FirstVisitImage;
